import classNames from "classnames";

const CR_SCORE: Record<string, string> = {
  274: "0:0",
  276: "1:0",
  278: "2:0",
  280: "3:0",
  282: "4:0",
  284: "0:1",
  286: "1:1",
  288: "2:1",
  290: "3:1",
  292: "4:1",
  294: "0:2",
  296: "1:2",
  298: "2:2",
  300: "3:2",
  302: "4:2",
  304: "0:3",
  306: "1:3",
  308: "2:3",
  310: "3:3",
  312: "4:3",
  314: "0:4",
  316: "1:4",
  318: "2:4",
  320: "3:4",
  322: "4:4",
  324: "AOS",
};

const HT_FT: Record<string, string> = {
  418: "HH",
  420: "HD",
  422: "HA",
  424: "DH",
  426: "DD",
  428: "DA",
  430: "AH",
  432: "AD",
  434: "AA",
};

export type BetPriceType =
  | "ah"
  | "ou"
  | "oe"
  | "x12"
  | "tob"
  | "ah1st"
  | "ou1st"
  | "x121st"
  | "tob1st"
  | "ml"
  | "ml1st"
  | "dc"
  | "awn"
  | "hwn"
  | "yn"
  | "ato"
  | "cr"
  | "1h/cr"
  | "2h/cr"
  | "hto"
  | "ht/ft";

export type Option = 0 | 1 | 2; // 0: home, 1: away, 2: draw

export type BettingTeamNameProps = {
  isHomeGoodTeam: boolean;
  isAwayGoodTeam: boolean;
  home: string;
  away: string;
  betPriceType: BetPriceType;
  option?: Option;
  outcomeId?: string;
};

const BettingTeamName = (props: BettingTeamNameProps) => {
  switch (props.betPriceType) {
    case "oe":
      if (props.option === 0) {
        return <div className="italic font-semibold">Odd</div>;
      }
      return <div className="italic font-semibold">Even</div>;
    case "ou":
    case "ou1st":
    case "tob":
    case "tob1st":
    case "ato":
    case "hto":
      if (props.option === 0) {
        return <div className="italic font-semibold">Over</div>;
      }
      return <div className="italic font-semibold">Under</div>;
    case "1h/cr":
    case "2h/cr":
    case "cr":
      return (
        <div className="italic font-semibold">
          {CR_SCORE[props.outcomeId ?? ""]}
        </div>
      );
    case "ht/ft":
      return (
        <div className="italic font-semibold">
          {HT_FT[props.outcomeId ?? ""]}
        </div>
      );
    case "yn":
    case "hwn":
    case "awn":
      if (props.option === 0) {
        return <div className="italic font-semibold">Yes</div>;
      }
      return <div className="italic font-semibold">No</div>;
    default:
      if (props.option === 0) {
        return (
          <div
            className={classNames("italic font-semibold", {
              "text-red-500": props.isHomeGoodTeam,
            })}>
            {props.home}
          </div>
        );
      } else if (props.option === 1) {
        return (
          <div
            className={classNames("italic font-semibold", {
              "text-red-500": props.isAwayGoodTeam,
            })}>
            {props.away}
          </div>
        );
      }
      return <div>Draw</div>;
  }
};

export default BettingTeamName;
